import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IMLLog } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

@Injectable()
export class MLLogsService extends ODataService<IMLLog, string> {
    protected _endpoint = '/odata/MLLogs';

    constructor(http: HttpClient) {
        super(http, MapperService.mlLogMap);
    }
}
